import THEMES from 'constants/theme'
import { colors } from '@material-ui/core'

const styles = (theme) => ({
  root: {
    border: 0,
    zIndex: theme.zIndex.drawer + 100,
    height: '60px',
    backgroundColor: theme.palette.primary.main,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.background.topBar,
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.topBar,
        }
      : {}),
  },
  logo: {
    fontSize: 0,
    width: '130px',
    [theme.breakpoints.up('md')]: {
      width: '130px',
    },
  },
  toolbar: {
    minHeight: 60,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  helpChip: {
    backgroundColor: colors.green[500],
    color: theme.palette.white,
    fontSize: 14,
    fontWeight: 500,
    minWidth: 85,
    height: 39,
    borderRadius: 100,
    '&:hover': {
      backgroundColor: colors.green[600],
      cursor: 'pointer',
    },
  },
  iconChip: {
    color: theme.palette.white,
    fontSize: 24,
    height: 21,
    width: 21,
  },
})

export default styles
